export enum AuthModalType {
  Login = 1,
  Register = 2,
  ForgotPassword = 3,
}
